module.exports = __webpack_public_path__ + "static/media/29BDOS24.a1185861.jpg";